export class OrderLine {
  public id: number;
  public depot: string;
  public note: string;
  public customerCode: string;
  public weight: Float32Array;
  public dateReceived: Date;
  public product: any;
  public price: number;

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/_model/order-line.ts